import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play, CheckCircle2 } from 'lucide-react';
import { ParticleChair } from './ParticleChair';

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[#050505] text-white">
      {/* Background Ambience */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(20,20,30,1)_0%,_rgba(0,0,0,1)_100%)] opacity-80" />
      
      <div className="max-w-7xl mx-auto px-6 w-full grid lg:grid-cols-2 gap-12 items-center relative z-10">
        <div className="order-2 lg:order-1">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-sans font-bold leading-tight mb-6 tracking-tight">
              Let customers feel <br />
              your products
            </h1>
            
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl text-blue-400 font-medium mb-6">
                Boost sales with instant <br/>AI+AR visualization:
              </h2>
              
              <ul className="space-y-4 text-gray-300 text-lg max-w-lg">
                <li className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-blue-500 shrink-0 mt-0.5" />
                  <span className="leading-relaxed">Turn any photo or video into a 3D AR experience to showcase your products in authentic scale.</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-blue-500 shrink-0 mt-0.5" />
                  <span className="leading-relaxed">Place them directly in your customers' world.</span>
                </li>
              </ul>
            </div>
            
            <div className="flex flex-wrap gap-4 mt-10">
              <button className="group px-8 py-4 bg-white text-black rounded-full font-bold text-sm uppercase tracking-wider flex items-center gap-2 hover:bg-gray-200 transition-all">
                Schedule Demo Call
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
          </motion.div>
        </div>

        <div className="relative order-1 lg:order-2 h-[60vh] lg:h-[70vh] flex items-center justify-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="relative w-full h-full"
          >
            {/* Particle System */}
            <ParticleChair />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
